<template lang="pug">
.footer-subscription-form.md-flex.justify-between.items-end
  //- intro
  h6.w-1x2.ml-auto.mb-24.px-5.md-px-0.md-w-auto.md-m-0.md-mr-16.border-b.border-transp.cursor-pointer(v-html="intro", @click="$refs.input.focus(); $nextTick(() => $refs.input.select())")
  //-
  form.w-full.flex.justify-between.md-block.md-w-auto(@submit.prevent="submit", validate)
    //- (messages)
    .w-1x2.md-w-auto.md-mb-2.text-left
      p(v-if="msg", :class="{'text-red': status === 'error'}") {{ msg }}
    //- input + submit
    .w-1x2.md-w-auto.flex.px-5.md-px-0
      input.min-w-0.border-b.border-gray-800.uppercase(ref="input", v-model="email" type='email' placeholder='E-MAIL ADDRESS', required)
      input.border-b.border-gray-800.bg-transp.cursor-pointer.focus-bg-black.focus-text-white(type='submit' value="OK")

</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'FooterSubscriptionForm',
  data () {
    return {
      status: null,
      msg: null,
      email: ''
    }
  },
  computed: {
    ...mapState({
      intro: state => state.site && state.site.newsletter_intro
    })
  },
  methods: {
    async submit () {
      this.status = null
      this.msg = null
      try {
        const resp = await this.$store.dispatch('subscribeToNewsletter', this.email)
        //
        this.status = resp.status !== 200 ? 'error' : 'success'
        this.msg = resp.message
      } catch (e) {
        // error
        this.status = 'error'
        this.msg = e.message || 'Error'
      }
    }
  }
}
</script>

<style lang="postcss">
  .footer-subscription-form {
    & br {
      display: none;
    }
  }
</style>
